//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Lee',
  data () {
    return {
      defaultJson: {
        'Class I': `I 级：极低危
（0.4% 并发症）`,
        'Class III': `III 级：中危
（6.6% 并发症）`,
        'Congestive Heart Failure': '充血性心力衰竭',
        'Insulin Treatment for DM': '糖尿病接收胰岛素治疗',
        'High-risk Surgery': '高危手术',
        'Preop. Creatinine': '术前肌酐',
        'Class II': `II 级：低危
（0.9% 并发症）`,
        'Class IV': `IV 级：高危
（≥11% 并发症）`,
        'Hx of Cerebrovasc. Disease': '脑血管病史',
        'abdominal, thoracic': '腹部，胸部',
        'Coronary Artery Disease': '冠状动脉病变'
      },
      form: {
        highRiskSx: '0',
        cad: '0',
        chf: '0',
        hxCerbDis: '0',
        insulinDM: '0',
        c: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '从不'},
        {value: '10', name: '一周内'},
        {value: '5', name: '曾有'}
      ],
      dataList2: [
        {value: '0', name: '从不'},
        {value: '10', name: '6个月内'},
        {value: '5', name: '超过6个月'}
      ],
      logit: '...'
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        self.logit = '...'
        return '...'
      } else {
        console.log(form)
        let result = form.highRiskSx + form.cad + form.chf + form.hxCerbDis + form.insulinDM + (form.c > 2 ? 1 : 0)
        if (result === 0) {
          self.logit = self.defaultJson['Class I']
        } else if (result === 1) {
          self.logit = self.defaultJson['Class II']
        } else if (result === 2) {
          self.logit = self.defaultJson['Class III']
        } else {
          self.logit = self.defaultJson['Class IV']
        }
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/Lee.vue